<script lang="ts" setup>
import type { MapOptions, MapPropsData } from '~/components/map/Map.vue'
import type { ApiOfficeserviceOfficesData } from '~~/server/api/officeservice/offices/[slug]'

export interface PagesOfficesDetailMapProps {
    data: ApiOfficeserviceOfficesData
    modalTitle: string
    mapZoom?: number
}

const props = defineProps<PagesOfficesDetailMapProps>()

const lat = computed<number>(() => Number(props.data.lat))
const lng = computed<number>(() => Number(props.data.lng))
const options = ref<MapOptions>({
    height: '55rem',
    center: {
        lat: lat.value,
        lng: lng.value,
    },
    zoom: props.mapZoom,
    fitBounds: false,
})

const officeMarker = ref<MapMarker>({
    lng: lng.value,
    lat: lat.value,
    data: props.data,
    title: `${props.data.address} ${props.data.city}`,
})

const mapData = ref<MapPropsData>({
    mapOptions: options.value,
    markers: [officeMarker.value],
})
</script>
<template>
  <div
    id="nase-pobocky-a-servisy"
    class="bg-white rounded box-shadow-1 overflow-hidden mb-12 mb-md-20 position-relative scroll-margin-top-11"
  >
    <Map :data="mapData">
      <template #modal="marker: any">
        <MapModalOffice
          :title="props.modalTitle"
          :office="marker.data"
        >
          <template #button>
            <PagesOfficesDetailNavLink
              :latitude="marker.data.lat"
              :longitude="marker.data.lng"
            />
          </template>
        </MapModalOffice>
      </template>
    </Map>
  </div>
</template>
